// Mirrors Finkit.Permissions.HostPagesPermissions.FinkitHostPagesPermissions
// .DeploymentNotice (GroupName = "HostPages").
export const DeploymentNoticePermissions = {
  view: 'HostPages.DeploymentNotice',
  manage: 'HostPages.DeploymentNotice.Manage',
} as const;
